var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.category != null
    ? _c(
        "main",
        { staticClass: "category" },
        [
          _c("header", { staticClass: "category-header" }, [
            _c("div", { staticClass: "heading-container" }, [
              _c("div", {
                staticClass: "image-container d-none d-sm-block",
                style: {
                  backgroundImage:
                    "url(" +
                    (_vm.category["acf"]["desktop_image"]
                      ? _vm.category["acf"]["desktop_image"]
                      : "/img/category-banner.png") +
                    ")"
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "image-container d-block d-sm-none",
                style: {
                  backgroundImage:
                    "url(" +
                    (_vm.category["acf"]["mobile_image"]
                      ? _vm.category["acf"]["mobile_image"]
                      : _vm.category["acf"]["desktop_image"]
                      ? _vm.category["acf"]["desktop_image"]
                      : "/img/category-banner.png") +
                    ")"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "overlay" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "heading",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.category["acf"]["heading"]
                      ? _vm.category["acf"]["heading"]
                      : _vm.category.name
                  )
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "container-fluid category-details" }, [
              _vm.category["acf"]["sub_heading"]
                ? _c("h1", {
                    staticClass: "sub-heading",
                    domProps: {
                      innerHTML: _vm._s(_vm.category["acf"]["sub_heading"])
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.category["acf"]["short_text"]
                ? _c("div", {
                    staticClass: "short-text",
                    domProps: {
                      innerHTML: _vm._s(_vm.category["acf"]["short_text"])
                    }
                  })
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.showTabbedTeaser
            ? _c("tabbed-teaser", {
                attrs: {
                  "teaser-filter-params": _vm.teaserFilterParams,
                  "show-categories-filter-param": false
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4e2b30e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4e2b30e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/Category.vue
// module id = 646
// module chunks = 0